<template>
  <div style="max-height: 156px; overflow-y: auto">
    <a-flex
      v-if="selectedConditionGroup && conditionGroupDataList?.length > 0"
      style="padding-left: 24px; padding-bottom: 10px"
    >
      <a-space
        wrap
        style="margin-bottom: 0"
      >
        <span>{{ $t('按{label}分组', { label: selectedConditionGroup.label }) }}:</span>
        <a-tooltip
          placement="bottom"
          v-for="item in conditionGroupDataList"
          :key="item.group_info.value"
          :title="`${item.group_info.display_name ? item.group_info.display_name : $t('空')}`"
        >
          <a-button
            style="padding: 0"
            :class="currentGroupConditionValue == item.group_info.value ? 'link-button' : ''"
            :type="currentGroupConditionValue == item.group_info.value ? 'link' : 'text'"
            :value="item.group_info.value"
            @click="handleChangeConditionGroupValue(item.group_info.value)"
          >
            <a-space :size="3">
              <span
                :class="
                  currentGroupConditionValue == item.group_info.value ? 'active-text' : 'text'
                "
              >
                {{ item.group_info.display_name ? item.group_info.display_name : $t('空') }}
              </span>
              <a-badge
                :count="item.count"
                :overflowCount="9999999999"
                :number-style="
                  currentGroupConditionValue == item.group_info.value
                    ? { backgroundColor: '#f0f9ff', color: '#1b9aee', fontWeight: 600 }
                    : { backgroundColor: '#f0f9ff', color: '#1b9aee' }
                "
              />
            </a-space>
          </a-button>
        </a-tooltip>
        <span>
          <a-button
            type="link"
            @click="handleClearConditionGroup"
          >
            {{ $t('取消分组') }}
          </a-button>
        </span>
      </a-space>
    </a-flex>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { Table } from './typing';
import { getCurrentGroupConditionValue } from './utils';

interface Props {
  config: Table;
  selfEventBus: any;
}
const props = withDefaults(defineProps<Props>(), {
  config: null,
});
const emit = defineEmits(['change']);
const selectedConditionGroup = defineModel('selectedConditionGroup', {
  default: null,
});
const conditionGroupDataList = defineModel<any[]>('conditionGroupDataList', {
  default: null,
});
const groupConditionValue = defineModel('groupConditionValue', {
  default: null,
});
const handleClearConditionGroup = () => {
  conditionGroupDataList.value = [];
  selectedConditionGroup.value = null;
  groupConditionValue.value = null;
  emit('change', groupConditionValue.value);
  props.selfEventBus.emit('refresh');
};
const handleChangeConditionGroupValue = (value: string) => {
  groupConditionValue.value = value;
  emit('change', value);
  props.selfEventBus.emit('refresh');
};
const currentGroupConditionValue = computed(() => {
  return getCurrentGroupConditionValue(conditionGroupDataList.value, groupConditionValue.value)
    ?.value;
});
</script>
